<template>
  <div style="max-width: 100%">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="10"
          md="10"
          lg="10"
          class="d-flex flex-wrap"
        >
          <v-row
            v-if="exibirChips"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-tooltip
                v-for="chip in appliedFilters"
                :key="chip.label"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    class="ma-1"
                    color="#e8f1ff"
                    text-color="#2863af"
                    small
                    :close="!['dataInicio', 'dataFim'].includes(chip.key)"
                    v-on="on"
                    @click:close="removeFilter(chip.key)"
                  >
                    {{ chip.label }}
                  </v-chip>
                </template>
                <span>{{ getTooltipValue(chip) }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          lg="2"
          class="d-flex justify-end"
        >
          <v-btn
            v-if="exibirChips"
            text
            :color="corPrimaria"
            @click="updateDate()"
          >
            <v-icon>
              mdi-reload-alert
            </v-icon>
            Consultar
          </v-btn>
          <v-btn
            text
            style="color: #2863af;"
            @click="toggleDrawer"
          >
            <v-icon>{{ drawer ? 'mdi-filter-minus' : 'mdi-filter-plus' }}</v-icon>
            {{ drawer ? 'Fechar filtros' : 'Filtros' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer
      v-model="drawer"
      right
      temporary
      width="600"
      fixed
      attach="body"
      class="pa-4 elevation-10 drawerFiltros"
      style="z-index: 3000;"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <transition name="filters">
              <v-row>
                <v-col
                  v-if="permissaoGestaoComercial === 'Usuário' && primeiro"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedPrimeiroDia"
                        class="text-h6"
                        label="Data Inical"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        disabled
                        v-bind="attrs"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="primeiroDia"
                      no-title
                      @input="menu3 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('primeiroDia')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu3 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="permissaoGestaoComercial !== 'Usuário' && primeiro"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedPrimeiroDia"
                        label="Data Inical"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="primeiroDia"
                      no-title
                      @input="menu3 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('primeiroDia')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu3 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="permissaoGestaoComercial === 'Usuário' && ultimo"
                  id="menu2"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        class="text-h6"
                        label="Data Final"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        disabled
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu4 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('dataFinal')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu4 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="permissaoGestaoComercial !== 'Usuário' && ultimo"
                  id="menu2"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Data Final"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu4 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('dataFinal')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu4 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="empresas"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="select"
                    :items="empresa"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Empresas"
                    multiple
                    return-object
                    @change="filtrarEmpresa()"
                  />
                </v-col>
                <v-col
                  v-if="produtores"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectProdutores"
                    :items="filterProdutores.length > 0 ? filterProdutores : produtor"
                    item-value="idExibicao"
                    item-text="produtor"
                    label="Produtores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.produtor }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.produtor }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectProdutores.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="linhas"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectLinha"
                    :items="filterLinha.length > 0 ? filterLinha : linhasleite"
                    item-value="idExibicao"
                    item-text="linha"
                    label="Linhas de leite"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.linha }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.linha }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectLinha.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-btn
                    id="btnRefazer"
                    class="col-12 lg-12 text-h4"
                    small
                    :color="corPrimaria"
                    dark
                    @click="updateDate()"
                  >
                    <v-icon>
                      mdi-reload-alert
                    </v-icon>
                    Refazer
                  </v-btn>
                </v-col>
              </v-row>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>
<script>
  import eventoEmit from './EventoEmit'

  export default {
    name: 'DashboardCoreFiltroDatas',
    emits: ['updateDados'],
    components: {
      DashboardCoreSnackbar: () => import('./Snackbar'),
    },
    props: {
      primeiro: {
        type: Boolean,
        default: false,
      },
      ultimo: {
        type: Boolean,
        default: false,
      },
      empresas: {
        type: Boolean,
        default: false,
      },
      url: {
        type: String,
        default: '',
      },
      produtores: {
        type: Boolean,
        default: false,
      },
      linhas: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      esconder: false,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      permissaoGestaoComercial: '',
      empresa: [],
      produtor: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      selectProdutores: [],
      filterProdutores: [],
      linhasleite: [],
      selectLinha: [],
      filterLinha: [],
      expandFiltro: false,
      icone: 'mdi-chevron-down',
      textFiltro: 'Exibir Filtro',
      drawer: false,
      exibirChips: false,
    }),

    computed: {
      filtros () {
        this.montarDadosFiltros(this.$store.state.filtros)

        return this.$store.state.filtros
      },

      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },

      appliedFilters () {
        const chips = []
        var i = 0

        if (this.primeiro) {
          chips.push({
            key: 'dataInicio',
            label: `Início: ${this.formatDatePrimeiroDia(this.primeiroDia)}`,
          })
        }

        if (this.ultimo) {
          chips.push({
            key: 'dataFim',
            label: `Fim: ${this.formatDatePrimeiroDia(this.date)}`,
          })
        }

        if (this.select?.length) {
          const empresaAux = []

          for (i in this.select) {
            empresaAux.push(this.select[i].nomeExibicao)
          }

          chips.push({
            key: 'empresas',
            label: `Empresa(s) (${this.select.length})`,
            value: empresaAux,
          })
        }

        if (this.selectProdutores?.length) {
          const produtoresAux = []

          for (i in this.selectProdutores) {
            produtoresAux.push(this.selectProdutores[i].produtor + ' - ' + this.selectProdutores[i].nomeBd)
          }

          chips.push({
            key: 'produtores',
            label: `Produtor(es) (${this.selectProdutores.length})`,
            value: produtoresAux,
          })
        }

        if (this.selectLinha?.length) {
          const linhasAux = []

          for (i in this.selectLinha) {
            linhasAux.push(this.selectLinha[i].linha + ' - ' + this.selectLinha[i].nomeBd)
          }

          chips.push({
            key: 'linhas',
            label: `linha(s) (${this.selectLinha.length})`,
            value: linhasAux,
          })
        }

        return chips
      },
    },

    watch: {
      'filtros.empresas': {
        immediate: true,
        handler (empresa) {
          if (empresa && empresa.length === 1) {
            this.select = [...empresa]
          }
        },
      },

      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },

      primeiro: function (val) {
        this.primeiro = val
      },

      ultimo: function (val) {
        this.ultimo = val
      },

      empresas: function (val) {
        this.empresas = val
      },

      url: function (val) {
        this.url = val
      },

      linhas: function (val) {
        this.linhas = val
      },

      produtores: function (val) {
        this.produtores = val
      },
    },

    mounted () {
      if (localStorage.updateDadosFiltros) {
        this.primeiroDia = localStorage.getItem('dataInicial')
        this.date = localStorage.getItem('dataFinal')
      }

      this.$store.dispatch('carregarFiltros')

      this.exibirChips = true
    },

    methods: {
      montarDadosFiltros (dados) {
        this.empresa = dados.empresa

        if (this.empresa.length === 1) {
          this.select = this.empresa
        }

        this.produtor = dados.produtor
        this.linhasleite = dados.linhasleite
      },

      toggleDrawer () {
        this.drawer = !this.drawer
      },

      definirHoje (item) {
        const hoje = new Date()

        if (item === 'primeiroDia') {
          this.primeiroDia = hoje.toISOString().substr(0, 10)
        } else if (item === 'dataFinal') {
          this.date = hoje.toISOString().substr(0, 10)
        }
      },

      expandirFiltro () {
        if (this.icone === 'mdi-chevron-up') {
          this.expandFiltro = false
          this.icone = 'mdi-chevron-down'
          this.textFiltro = 'Exibir Filtro'
        } else {
          this.textFiltro = 'Recolher Filtro'
          this.expandFiltro = true
          this.icone = 'mdi-chevron-up'
        }
      },

      removeFilter (key) {
        switch (key) {
          case 'empresas':
            this.select = []
            break
          case 'produtores':
            this.selectProdutores = []
            break
          case 'linhas':
            this.selectLinha = []
            break
          case 'dataInicio':
            break
          case 'dataFim':
            break
        }
      },

      getTooltipValue (chip) {
        if (Array.isArray(chip.value)) {
          return chip.value.join(', ')
        }

        return chip.label
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date(this.primeiroDia).getFullYear(), new Date(this.primeiroDia).getMonth() + 4, 0).toISOString().substr(0, 10)

        if (date > dataLimite) {
          var data = new Date(new Date(this.primeiroDia).getFullYear(), new Date(this.primeiroDia).getMonth() + 2, 0).toISOString().substr(0, 10)

          this.date = data

          const [year, month, day] = data.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      updateDate () {
        eventoEmit.$emit('update-dados', this.primeiroDia, this.date, this.select, this.selectProdutores, this.selectLinha)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      filtrarEmpresa () {
        this.filterProdutores = []
        this.filterLinha = []

        if (this.select && this.select.length > 0) {
          this.select.forEach(empresa => {
            const produtoresAux = this.produtor.filter(v => v.nomeBd === empresa.nome_bd)

            this.filterProdutores.push(...produtoresAux)

            const linhaAux = this.linhasleite.filter(l => l.nomeBd === empresa.nome_bd)

            this.filterLinha.push(...linhaAux)
          })
        }

        this.filterProdutores.sort((a, b) => a.produtor.localeCompare(b.produtor))

        this.filterLinha.sort((a, b) => a.linha.localeCompare(b.linha))
      },
    },

  }
  </script>

  <style scoped>
    .drawerFiltros {
      top: 65px !important;
      height: auto !important;
      max-height: calc(100vh - 65px);
      overflow-y: auto;
      box-shadow: -2px 0 12px rgba(0,0,0,0.25);
    }

    .filters-enter-active {
      animation: enter .5s cubic-bezier(.34,1.56,.64,1);
    }

    .filters-leave-active {
      animation: leave .5s ease;
    }

    @keyframes enter {
      0% {
        opacity: 0;
        transform: scale(.85) translateY(-20px);
      }
      55% {
        opacity: 1;
        transform: scale(1.05) translateY(4px);
      }
      85% {
        transform: scale(0.98) translateY(0px);
      }
      100% {
        transform: scale(1) translateY(0);
      }
    }

    @keyframes leave {
      0% {
        opacity: 1;
        transform: scale(1) translateY(0);
      }
      100% {
        opacity: 0;
        transform: scale(.90) translateY(-15px);
      }
    }

    @media screen
    and (min-device-width : 320px)
    and (max-device-width : 560px) {
      .filterMobile{
        display: block
      }

      .filterWeb{
        display: none
      }

      .container {
        display: flex;
        flex-wrap: wrap;
      }

      .cell {
        display: flex;
        align-items: center;
        height: 100px;
      }

      .item {
        flex-grow: 1;
        flex-basis: 100%;
        min-width: 360px;
      }

      #btnRefazer {
        font-size: 10px;
        margin-top: 2rem;
        margin-left: -0.4rem;
      }
    }

    @media screen
    and (min-width : 481px)
    and (max-width : 960px)
    and (-webkit-min-device-pixel-ratio: 1) {
      .filterMobile{
        display: none
      }

      .filterWeb{
        display: block
      }

      #btnRefazer {
        font-size: 12px;
        display: flex;
        max-width: 15vw;
      }

      .container {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      }

      .cell {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100px;
      }

      .item {
        flex-grow: 1;
        flex-basis: 100%;
        min-width: 360px;
        max-width: 840px;
      }
    }
  </style>

  <style lang="sass">
    .filterMobile
      display: none

    .filterWeb
      display: block

    #btnRefazer
      margin: 1.5rem auto

  </style>
